module.exports = __webpack_public_path__ + "static/media/Account-icon.91491b93.svg";